<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" ></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="enjoyTreat"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign4.png"> 我的待遇</span></h2>
              <div v-if="!dataList || this.$util.isEmpty(dataList.personUid)" style="font-size: 12px;text-align: center;margin-top: 50px;">
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </div>
              <div v-else>
                <div v-if=" dataList.archiveTyeData &&  dataList.archiveTyeData.length>0">
                  <h3 class="details_tit2" style="margin-top: 20px">
                    <span style="margin-right: 24px">姓名：{{dataList.personName}}</span>
                    <span style="margin-right: 24px">性别：{{dataList.personSexName}}</span>
                    <span style="margin-right: 24px">身份证号：{{dataList.personUid}}</span>
                  </h3>
                  <div  v-for="(archive,index) in dataList.archiveTyeData" :key="index" style="text-align: center">
                    <div style="font-size:14px; color:#848484; text-align:center; padding-top:24px;width: 75%;margin: 0 auto;text-align: left;">
                      <span style="margin-right: 54px"> 待遇名称：{{archive.archiveTypeName}}</span>
                      <span style="float: right;margin-right: 10px;"> 状态：{{archive.archiveStatusName}}</span>
                    </div>
                    <table width="75%" border="0" cellspacing="1" cellpadding="0" class="enjoy_tab" style="margin-left:auto;margin-right:auto;margin-top:10px;float: none">
                      <tr class="enjoy_tit">
                        <td width="25%">资金科目</td>
                        <td width="25%">标准金额（元）</td>
                        <td width="25%">发放周期</td>
                      </tr>
                      <tr v-for="(classItem,index) in archive.classData" :key="index">
                        <td>{{classItem.className}}</td>
                        <td>{{classItem.standardAmount}}</td>
                        <td>{{classItem.frequency}}</td>
                      </tr>
                    </table>
                  </div>

                </div>
                <div v-else>
                  <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                    <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                    <div>暂无数据</div>
                  </div>

                </div>
              </div>
              <div style="width: 100%;height: 50px;"></div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";
  export default {
    name: "CardMaking",
    components: {
      headers, fixedDiv, footers,personal
    },
    data() {
      return {
        dataList: [],
      };
    },
    mounted() {
      this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.isCertification=='1'){
            this.searchData(response.data.data.userIdcard);
          }
        }
      })
    },
    methods: {
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      searchData(person_uid) {
        if (this.$util.isEmpty(person_uid)) return;
        this.$https.post("/api/zj/getAllEnjoyTreat.do", {person_uid: person_uid}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)) {
              this.dataList = response.data.data;
            }
          }
        });
      },
    }
  }
</script>

<style>
  .stepDivCss .el-step__description {
    padding-right: 10%;
    margin-top: -5px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 20px;
    color:#85888e;
  }
  .stepDivCss .el-step__title {
    font-size: 14px;
    line-height: 38px;
    font-weight: 600;
    color: #303133;
  }
  .personal_right .el-card__header {
    padding: 9px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #f7f7f7;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personal/EnjoyTreat.vue